// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:1025px){.contentParty[data-v-4905b3da]{display:block!important}}", ""]);
// Exports
module.exports = exports;
